// 개인정보의 AI 학습, 모델 고도화 동의
const AiTrainingConsent = `주식회사 퍼니즈(이하 "회사")는 Castar 서비스에서 제공하는 AI 기반 얼굴 분석, 카테고라이제이션, 추천 모델 고도화 기능을 위해 이용자의 개인정보를 아래와 같이 추가로 이용할 수 있습니다.

본 동의는 선택사항이며, 동의하지 않아도 서비스 이용에 제한이 없으나 AI 기반 추천 기능의 정확도가 일부 제한될 수 있습니다.

본 약관은 대한민국 개인정보보호법 및 개인정보보호위원회 AI 가이드라인(2024)을 기준으로 합니다.

제1조(처리 목적)

회사는 아래 목적 범위 내에서 이용자의 정보를 AI 학습 및 모델 개선에 활용합니다.

1. 배우 프로필·포트폴리오 기반 얼굴 이미지 분석 및 카테고라이제이션
  - 예: "귀여운", "청순한", "성숙한", "대학생 느낌" 등 이미지/스타일 분류
2. 나이대, 성별, 외형 특징 등 배역 적합성 분석 모델 고도화
3. 제작사 요구조건(배역 이미지·분위기·역할 속성 등)에 맞춘 추천 정확도 향상
4. 신규 알고리즘 개발 및 서비스 품질 개선
5. 서비스 오류 탐지 및 AI 기능 안정화

※ 회사는 상기 목적 외 용도로 정보를 사용하지 않습니다.

제2조(수집·이용 항목)

AI 학습을 위해 아래 항목을 이용할 수 있습니다.

1. 배우 사진 및 영상
  - 프로필 사진(안면·전신), 연기 영상, 자기소개 영상 등
  - 표정·외형·이미지 분석이 가능한 기타 비주얼 자료
2. 포트폴리오 정보
  - 신체 정보(키·몸무게 등)
  - 프로필 서술 내용(자기소개, 특기, 이미지 키워드 등)
3. 서비스 이용 과정에서 생성되는 정보
  - 포트폴리오 업데이트 내역
  - 카테고리 태깅 결과
  - 추천 노출 및 선택 기록 등

※ 민감정보(건강, 종교, 정치성향 등)는 수집·이용하지 않으며, AI 모델이 자동으로 생성하는 특성 중 민감정보는 저장·활용하지 않습니다.

제3조(이용 및 처리 방식)

1. 회사는 수집된 개인정보를 이용하여 이미지 특징 추출, 딥러닝 모델 훈련, 카테고리 태깅 등을 수행합니다.
2. 학습 데이터는 비식별화 조치를 적용하여 관리합니다.
3. AI 학습은 회사 내부 시스템 또는 위탁된 안전한 환경에서 수행할 수 있습니다.

제4조(보유 및 이용 기간)

1. 학습용 데이터 원본은 AI 학습 목적 달성 시까지 보유합니다.
2. 회원 탈퇴 또는 동의 철회 시 즉시 원본 데이터를 삭제합니다.
3. 단, 탈퇴·철회 이전에 이미 학습된 AI 모델 내부에 잔존하는 데이터는 기술적 한계로 완전 삭제가 불가능할 수 있으나, 모델 재학습 또는 비식별화 조치를 통해 활용을 최소화합니다.

제5조(동의의 선택권 및 철회권)

1. 본 동의는 선택적이며, 동의하지 않아도 Castar 서비스 이용에는 제한이 없습니다.
2. 이용자는 언제든지 마이페이지 또는 고객센터를 통해 동의를 철회할 수 있으며, 회사는 즉시 처리합니다.
3. 철회 시, 학습 데이터 원본은 파기됩니다.

제6조(안전성 확보조치)

회사는 개인정보보호법 제29조 및 관련 고시에 따라 아래 조치를 시행합니다.

1. 이미지·영상 데이터 암호화 저장
2. 접근 권한 최소화 및 권한관리 통제
3. 내부 개발망 분리 등 물리적 보안 조치
4. AI 모델 관리·운영 기록 보관
5. 비식별화 처리 및 안전조치 수행
6. 위탁업체에 대한 감독 및 관리

제7조(위탁 및 제3자 제공 없음)

1. 본 동의에 따라 수집된 정보는 오직 회사 내부 AI 학습 용도로만 사용됩니다.
2. 제작사·외부 기업 등 제3자에게 제공되지 않습니다.
3. 외부 AI 연구기관과 공동 학습이 필요할 경우, 별도의 사전 동의(추가 동의) 절차가 진행됩니다.

제8조(동의 거부 및 불이익)

1. 이용자는 본 동의를 거부할 수 있습니다.
2. 동의 거부 시 서비스 가입 및 기본 이용에 제한은 없습니다.

제9조(동의 문구)

"본인은 주식회사 퍼니즈가 Castar 서비스의 AI 기반 얼굴 분석·카테고리 태깅 및 추천 모델 고도화를 위해 본인의 개인정보(사진·영상·프로필 등)를 위와 같은 범위에서 이용하는 것에 동의합니다."`;

export default AiTrainingConsent;
